import React from 'react';
import type { AuditPayload, HealthSegment } from '../types';

const BAR_COLOR: Record<HealthSegment, string> = {
  unmanaged: '#dc2626',
  amateur:   '#d97706',
  agency:    '#1E2D45',
  optimized: '#76C043',
};

const KpiCards: React.FC<{ payload: AuditPayload }> = ({ payload }) => (
  <div className="grid grid-cols-2 md:grid-cols-4 border-y border-slate-200 divide-x divide-slate-200">
    <div className="px-4 py-4">
      <div className="text-[11px] text-slate-500 mb-1">マップ順位</div>
      <div className="text-2xl font-semibold text-slate-900 tabular-nums leading-none">
        {payload.rank}<span className="text-sm text-slate-500 font-normal"> 位</span>
      </div>
      <div className="text-[11px] text-slate-500 mt-2">取得20店舗中</div>
    </div>
    <div className="px-4 py-4">
      <div className="text-[11px] text-slate-500 mb-1">MEO 健全度</div>
      <div className="text-2xl font-semibold text-slate-900 tabular-nums leading-none">
        {payload.health_score}<span className="text-sm text-slate-500 font-normal">/100</span>
      </div>
      <div className="bg-slate-200 h-1 mt-3 overflow-hidden">
        <div className="h-full transition-all" style={{ width: `${payload.health_score}%`, background: BAR_COLOR[payload.health_segment] }} />
      </div>
    </div>
    <div className="px-4 py-4">
      <div className="text-[11px] text-slate-500 mb-1">平均評価</div>
      <div className="text-2xl font-semibold text-slate-900 tabular-nums leading-none">
        {payload.rating !== null ? payload.rating.toFixed(1) : '-'}
      </div>
      <div className="text-[11px] text-slate-500 mt-2">口コミ {payload.review_count ?? 0} 件</div>
    </div>
    <div className="px-4 py-4">
      <div className="text-[11px] text-slate-500 mb-1">写真</div>
      <div className="text-2xl font-semibold text-slate-900 tabular-nums leading-none">
        {payload.photo_count}<span className="text-sm text-slate-500 font-normal"> 枚</span>
      </div>
      <div className="text-[11px] text-slate-500 mt-2">推奨 20枚以上</div>
    </div>
  </div>
);

export default KpiCards;
